module.exports = __webpack_public_path__ + "static/media/signal-alt-1.2da2835b.svg";